var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3497 12.5531C15.3497 14.2991 13.9337 15.7141 12.1877 15.7141C10.4417 15.7141 9.02667 14.2991 9.02667 12.5531C9.02667 10.8061 10.4417 9.39111 12.1877 9.39111C13.9337 9.39111 15.3497 10.8061 15.3497 12.5531Z",
    stroke: "#1E2948",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1862 19.855C15.9942 19.855 19.4772 17.117 21.4382 12.553C19.4772 7.98898 15.9942 5.25098 12.1862 5.25098H12.1902C8.38217 5.25098 4.89917 7.98898 2.93817 12.553C4.89917 17.117 8.38217 19.855 12.1902 19.855H12.1862Z",
    stroke: "#1E2948",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeOpen);
export default __webpack_public_path__ + "static/media/icon-eye-open.645f590d119fb25cd4719a746ad3e3bf.svg";
export { ForwardRef as ReactComponent };